import { createTheme } from '@mui/material/styles';

export const buildTheme = (mode) =>
  createTheme({
    palette: {
      mode,
      primary: { main: mode === 'dark' ? '#7aa2f7' : '#1f6feb' },
      secondary: { main: mode === 'dark' ? '#bb9af7' : '#8250df' },
      background: {
        default: mode === 'dark' ? '#0f1115' : '#f6f8fa',
        paper: mode === 'dark' ? '#161b22' : '#ffffff',
      },
    },
    shape: { borderRadius: 10 },
    typography: {
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      h1: { fontSize: '1.75rem', fontWeight: 600 },
      h2: { fontSize: '1.25rem', fontWeight: 600 },
      h3: { fontSize: '1rem', fontWeight: 600 },
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: { backgroundImage: 'none' },
        },
      },
      MuiButton: {
        defaultProps: { disableElevation: true },
      },
    },
  });
